module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_57.42d37bc3.png";